import React, { useState,useEffect,memo } from 'react';

function MediaInput(props){
    const [name,setName] =  useState('');
    useEffect(()=>{
        if(props.value){
            setName(props.value)
        }
    },[props])
    const handleName = (e) =>{
        setName(e.target.value)
    }
    return (
        <>
           <input className={`${props.class} upload_media_field`} type={"text"} id={props.id} value={name} onChange={(e)=>{handleName(e)}} placeholder={props.placeholder}/>
        </>
    );
}

export default memo(MediaInput)